import React from 'react';
import './style.css';

interface IJoinTeam {
  placeholder: string;
  formLink: string;
  content: string;
}

const JoinTeam: React.FC<IJoinTeam> = ({placeholder, formLink, content}) => {
  return (
    <div className="joinT">
      <h3>{content} </h3>
      {/* ********Team ending here ***** 
      <a href={formLink}>
        <Btn type={placeholder} overlay="Llena el formulario" link={formLink} />
      </a>
      */}
    </div>
  );
};

const Member = ({info}: {info: any}) => {
  const {github, role, name, img} = info;
  return (
    <div className="member">
      <img src={img} alt={name}></img>
      <div className="members-link">
        <h3>{name}</h3>
        <a href={github}>
          <i className="fas fa-link"></i>
        </a>
      </div>
    </div>
  );
};

const Judge = ({info}: {info: any}) => {
  const {filiation, role, name, img} = info;
  return (
    <div className="member">
      <img src={img} alt={name}></img>
      <div className="members-link">
        <h3>{name}</h3>
        <p>{filiation}</p>
      </div>
    </div>
  );
};

const Speaker = ({info}: {info: any}) => {
  const {talk, talkVideo, name, img} = info;
  return (
    <div className="member">
      <img src={img} alt={name}></img>
      <div className="members-link">
        <h3>{name}</h3>
        <h4>Keynote</h4>
        <p>{talk}</p>
      </div>
    </div>
  );
};

const Challenger = ({info}: {info: any}) => {
  const {challenge, name, img} = info;
  return (
    <div className="member">
      <img src={img} alt={name}></img>
      <div className="members-link">
        <h3>{name}</h3>
        <h4>Reto</h4>
        <p>{challenge}</p>
      </div>
    </div>
  );
};

export {Challenger, JoinTeam, Judge, Member, Speaker};
